import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase from '../../../_common/platform/ts/ParameterFieldBase';
import { WidgetData } from '../../../_common/platform/ts/WidgetData';
import EditComponent, { IMultiWidgetFieldOptions } from '../tsx/multiWidgetField/MultiWidgetField';

export class MultiWidgetField extends ParameterFieldBase<IMultiWidgetFieldOptions> {
    public static EditComponent = EditComponent;
    public static defaultValidators = [
        (value, glob: IGlob) => {
            const find = _.find(value, (obj: any) => {
                const data = WidgetData.getFromObj(obj, glob, true);

                if (data.widget == null) {
                    return false;
                }

                return data.widget.isInvalid;
            });

            if (find != null) {
                return ['One of widgets has invalid configuration'];
            }
        }
    ];

    public getDefaultOptions(): IMultiWidgetFieldOptions {
        return {
            fix: (value, validators) => {
                return _.map(value, (obj) => {
                    return WidgetData.normalizeData(obj, this.glob);
                });
            }
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal: any[] = [], options?: IMultiWidgetFieldOptions, directOptions?) {
        super(glob, title, MultiWidgetField.defaultValidators, validators, defaultVal, options, directOptions);
    }
}
